export default __webpack_public_path__ + "static/media/1974.37334e0b.png";